import {Lang} from "../types";

export const LANG_KEY = "i18nextLng";

export const getCurrentLang = (): Lang => {
    const currentLang = localStorage.getItem(LANG_KEY);
    return (currentLang === Lang.RU || currentLang === Lang.EN) ? currentLang : Lang.EN;
};
